import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress the benign ResizeObserver loop warning produced by Recharts'
// ResponsiveContainer. The browser handles the undelivered notifications
// gracefully — this is purely cosmetic noise in the dev console.
const _origError = window.onerror;
window.onerror = (msg, ...args) => {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) return true;
  return _origError ? (_origError as any)(msg, ...args) : false;
};
const _origConsoleError = console.error.bind(console);
console.error = (...args: any[]) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) return;
  _origConsoleError(...args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
